import API_BASE from './config';

export function syncHistorical(raceId) {
    return fetch(`${API_BASE}/historical/sync`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ raceId }),
    }).then(async (res) => {
        if (!res.ok) {
            const payload = await res.json().catch(() => ({}));
            throw new Error(payload.error || 'Failed to sync historical data');
        }
        return res.json();
    });
}

export function getHistoricalData(params = {}) {
    const query = new URLSearchParams();
    if (params.circuitId) query.set('circuitId', params.circuitId);
    if (params.fromSeason != null) query.set('fromSeason', String(params.fromSeason));
    if (params.toSeason != null) query.set('toSeason', String(params.toSeason));

    const suffix = query.toString() ? `?${query.toString()}` : '';
    return fetch(`${API_BASE}/historical${suffix}`, {
        headers: { Accept: 'application/json' },
    }).then((res) => {
        if (!res.ok) throw new Error('Failed to fetch historical data');
        return res.json();
    });
}
